// Single source of truth for Retirement Readiness Toolkit™ pricing.
// Backend remains authoritative on the actual charge (server-side amount in
// /api/wealth/start). These values are for presentational use only.

export const PRODUCT_NAME = "Retirement Readiness Scorecard\u2122"; // the personalized output
export const TOOLKIT_NAME = "Retirement Readiness Toolkit\u2122"; // the wrapper product
export const COMPLETE_VALUE = 549.00; // "Complete Toolkit Value" (anchor price) — 12 resources incl. consultation
export const LAUNCH_PRICE = 29.95;
export const SAVINGS = COMPLETE_VALUE - LAUNCH_PRICE; // 519.05

// Kept for backwards compatibility with any existing references — points at the launch price.
export const REGULAR_PRICE = COMPLETE_VALUE;

export const LAUNCH_COPY =
    "During our initial launch period, you can access the complete Retirement Readiness Toolkit\u2122 for $29.95.";

export const CTA_BUTTON_LABEL = "Get My Toolkit for $29.95";
export const CTA_SUBTEXT = "One-time payment. No subscription. Educational resources only.";

// What the buyer gets — verbatim across every surface (landing, pricing card, emails, etc).
// Order is intentional: personalized scorecard first, general retirement planning
// in the middle, niche/specialty resources (Gold and Silver IRA, Annuity Guide) at the bottom
// so the bundle reads as a general retirement-planning kit, with annuities as just
// one component — not the headline.
export const TOOLKIT_INCLUDES = [
    {
        title: "Retirement Readiness Scorecard\u2122",
        meta: "Personalized 0-100 score across 4 dimensions \u00b7 printable PDF report",
    },
    {
        title: "Retirement Income Gap Worksheet",
        meta: "Fill-in calculator that reveals your exact monthly shortfall in under 10 minutes",
    },
    {
        title: "Social Security Maximization Guide",
        meta: "When to claim, spousal & survivor strategy, and the break-even math most retirees never run",
    },
    {
        title: "Retirement Tax Reduction Checklist",
        meta: "Line-by-line audit of the tax exposures most retirees miss until it's too late",
    },
    {
        title: "RMD & Withdrawal Sequencing Planner",
        meta: "The drawdown order that minimizes lifetime tax \u2014 with a fill-in projection table",
    },
    {
        title: "Medicare & Healthcare Cost Planner",
        meta: "Parts A/B/D, IRMAA brackets, supplemental coverage \u2014 budget the second-biggest cost in retirement",
    },
    {
        title: "Estate & Legacy Planning Checklist",
        meta: "Beneficiary audit, trust & POA review, and the SECURE Act traps that cost heirs six figures",
    },
    {
        title: "Retirement Document Organizer",
        meta: "The folder system your spouse, executor & advisor need \u2014 everything in one place",
    },
    {
        title: "IRA & 401(k) Rollover Checklist",
        meta: "Step-by-step process to move retirement assets without triggering a taxable event",
    },
    {
        title: "Gold and Silver IRA Guide",
        meta: "Buyer-protection playbook \u2014 diversify without the costly mistakes first-timers make",
    },
    {
        title: "Annuity Owner's Guide",
        meta: "Plain-English playbook to audit any annuity contract you own \u2014 or are pitched",
    },
    {
        title: "Optional 15-Minute Consultation",
        meta: "Complimentary second opinion with a licensed retirement pro \u2014 no sales, no follow-up",
    },
];

// Headline count — surfaces on the pricing card to make the package feel concrete.
export const TOOLKIT_COUNT_HEADLINE = "12 expert resources";
export const TOOLKIT_COUNT_BREAKDOWN = "1 personalized scorecard \u00b7 4 in-depth guides \u00b7 4 audit checklists \u00b7 2 fill-in worksheets \u00b7 1 optional consultation";

// Compliance bullets (small line under the includes list — never the marketing claim itself).
export const PRICING_BULLETS = TOOLKIT_INCLUDES;

export const COMPLIANCE_DISCLAIMER =
    "Educational and informational purposes only. Not financial, tax, legal, investment, or insurance advice. Consult a licensed professional for advice tailored to your individual circumstances.";

export const formatUSD = (n) =>
    n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });
